<template>
    <div class="vehicles-list__item">
        <div class="vehicles-list__item-info">
            <div class="vehicles-list__item-name">
                {{ vehicledata.year }} {{ vehicledata.makedesc }} {{ vehicledata.modeldesc }}
            </div>
            <div class="vehicles-list__item-details">
                {{ vehicledata.enginedesc }}
            </div>
            <!-- <div class="vehicles-list__item-details">VIN: </div> -->
            <!-- <div class="vehicles-list__item-links">
                <router-link to="/select-parts-drilldown">Show Parts</router-link>
            </div> -->
        </div>
        <!-- <button type="button" class="vehicles-list__item-remove" @click="$emit('remove-vehicle', index)">
            <svg width="16" height="16">
                <path
                d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z"
                />
            </svg>
        </button> -->
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        vehicledata: {
            type: Object,
            required: true
        }
    },
    // methods: {
    //     removeVehicle() {
    //         this.$emit("remove-vehicle", this.index);
    //     }
    // }
}
</script>